module.exports = __webpack_public_path__ + "img/plug.e0f4648b.svg";